export const transformDate = (utcDate) => {
  // Se crea un objeto Date a partir de la cadena en formato UTC
  const date = new Date(utcDate);

  // Definir el offset de 2 horas en milisegundos
  const offset = 2 * 60 * 60 * 1000;

  // Crear una nueva fecha ajustada sumándole el offset
  const adjustedDate = new Date(date.getTime() + offset);

  // Extraer el día
  const day = adjustedDate.getUTCDate();

  // Array con abreviaturas de los meses (en español)
  const monthNames = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];
  const month = monthNames[adjustedDate.getUTCMonth()];

  // Extraer las horas y minutos (usando métodos UTC ya que ajustamos manualmente la fecha)
  const hours = adjustedDate.getUTCHours();
  const minutes = adjustedDate.getUTCMinutes();

  // Asegurarse de que las horas y minutos tengan dos dígitos si es necesario
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  // Retornar el string con el formato deseado: "día/mes abreviado HH:MM"
  return `${day}/${month} ${formattedHours}:${formattedMinutes}`;
};
